import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import "./FailedReportsParseModal.css";

class FailedReportsParseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { fileFailedToParse, toggleFailedReportsParseModal } = this.props;
    return (
      <SweetAlert
        customClass="FailedReportsParseModal__SweetAlert"
        title=""
        showConfirm={false}
        onConfirm={() => {}}
        // onCancel={() => toggleFailedReportsParseModal()}
      >
        <div className="FailedReportsParseModal__Container">
          Following files failed to parse, please check the files and re-upload
          <br />
          <span className="FailedReportsParseModal__Span1">
            Expected format:
            {" "}
          </span>
          <span className="FailedReportsParseModal__Span2">
            Text
            <span className="FailedReportsParseModal__Span3">
              -
            </span>
            110011_110D1100R1100
            <span className="FailedReportsParseModal__Span3">
              -
            </span>
            Company Name
            <span className="FailedReportsParseModal__Span3">
              -
            </span>
            ER.
          </span>
          <span className="FailedReportsParseModal__Span4">
            pdf
          </span>
          <br />
          <span className="FailedReportsParseModal__Span1">
            Pesticide format:
            {" "}
          </span>
          <span className="FailedReportsParseModal__Span2">
            Text
            <span className="FailedReportsParseModal__Span3">
              -
            </span>
            110011_110D1100R12P
            <span className="FailedReportsParseModal__Span3">
              -
            </span>
            Company Name
            <span className="FailedReportsParseModal__Span3">
              -
            </span>
            ER.
          </span>
          <span className="FailedReportsParseModal__Span4">
            pdf
          </span>
        </div>

        {fileFailedToParse.length > 0
          && fileFailedToParse.map((file, index) => <div className="FailedReportsParseModal__FileList" key={index}>{file}</div>)}

        <div>
          <button
            type="button"
            className="FailedReportsParseModal__CloseBtn"
            onClick={() => toggleFailedReportsParseModal()}
          >
            Close
          </button>
        </div>
      </SweetAlert>
    );
  }
}

export default FailedReportsParseModal;
